import { render } from "./HistoryDetail.vue?vue&type=template&id=05bb8b3e"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__